import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavBar from "./components/nav-bar";
import Drawer from "./components/drawer";
import BackDrop from "./components/backdrop";

import "./styles/base.scss";
import Home from "./screens/home";
import Footer from "./components/footer";
import Menu from "./screens/menu";
import ContactUs from "./screens/contact-us";
import ErrorPage from "./screens/page-not-found";

function App() {
  const [drawer, setDrawer] = useState(false);
  const [category, setCategory] = useState("Soup");

  const drawerTogglerHandler = () => {
    setDrawer((prevState) => !prevState.setDrawer);
  };

  const backdropClickHandler = () => {
    setDrawer(false);
  };

  return (
    <div className="App">
      <Router>
        <NavBar toggleDrawer={drawerTogglerHandler} />
        <Routes>
          <Route path="/" element={<Home setCategory={setCategory}/>} />
          <Route path="/menu" element={<Menu category={category} setCategory={setCategory}/>} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <Footer />
        <Drawer showDrawer={drawer} setDrawer={setDrawer}/>
        {drawer && <BackDrop backdropClickHandler={backdropClickHandler} />}
      </Router>
    </div>
  );
}

export default App;
